import * as api from '@/employees/api'
import { storeAllEntities } from '@/helpers/store'
export default {
  state: {
    groups: {},
  },
  mutations: {},
  actions: {
    getGroups ({ commit }, { queryParams }) {
      return api.getGroups(queryParams)
        .then(storeAllEntities(commit))
    },
  },
  getters: {},
}
